<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Tanórán kívüli tevékenységek</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!--ion-card color="primary">
    <ion-card-header>
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Üdvözöljük a Sulinform felületén!</ion-card-title>
      <ion-card-subtitle>Válasszon a menük közül!</ion-card-subtitle>
    </ion-card-header>
  </ion-card-->

  <!-- CSALÁDI NÉZET: a gyermek(ek) jelentkezései és befizetései. A lezajlott tábor is
       látszik, amíg hátralék van rajta; az „Elmúltakat is" a teljes tanévet hozza. -->
  <ion-card *ngIf="!isPedagogusMode() && lathatoSajatBefizetesek.length">
    <ion-card-header>
      <ion-card-title>Jelentkezések és befizetések</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="tkt-befizetes-kartya" *ngFor="let t of lathatoSajatBefizetesek">
        <div class="tkt-bk-fej">
          <strong>{{ t.esemeny.nev }}</strong>
          <span class="tkt-bk-tanulo" *ngIf="tobbGyerek">{{ t.tanulo.nev }}</span>
          <ion-badge [color]="allapotSzin(t)">{{ allapotCimke(t) }}</ion-badge>
        </div>
        <div class="tkt-bk-datum">
          {{ t.esemeny.kezdes | date:'yyyy.MM.dd' }} – {{ t.esemeny.vege | date:'yyyy.MM.dd' }}
        </div>
        <div class="tkt-bk-szamok">
          <span *ngIf="t.ar">Ár: <b>{{ arSzoveg(t.esemeny) }}</b></span>
          <span>Befizetve: <b>{{ osszeg(t.befizetve, t.penznem) }}</b></span>
          <span *ngIf="t.hatralek !== null" [class.tkt-hatralek]="t.hatralek > 0">
            Hátralék: <b>{{ osszeg(t.hatralek, t.penznem) }}</b>
          </span>
        </div>
        <ion-progress-bar *ngIf="t.ar" [value]="haladas(t)" [color]="allapotSzin(t)"></ion-progress-bar>
        <ul class="tkt-bk-reszletek" *ngIf="t.befizetesek?.length">
          <li *ngFor="let b of t.befizetesek">
            {{ b.datum | date:'yyyy.MM.dd' }} – <b>{{ osszeg(b.osszeg, b.penznem) }}</b>
            <i *ngIf="b.megjegyzes"> ({{ b.megjegyzes }})</i>
          </li>
        </ul>
        <p class="tkt-bk-megjegyzes" *ngIf="!t.resztvevo">A jelentkezést azóta lemondták – a befizetés rendezéséhez keresd az iskolát.</p>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- TANULÓ-KERESŐ (munkatárs): melyik tevékenységekre jelentkezett a tanuló. Az összegek
       csak a kezelt tevékenységeknél jönnek (a kiszolgáló dönt). -->
  <ion-card *ngIf="isPedagogusMode()" class="tkt-kereso">
    <ion-card-content>
      <ion-searchbar [(ngModel)]="kereso" (ionInput)="keresoGepel()" (ionClear)="keresoTorles()"
                     placeholder="Tanuló keresése – melyik tevékenységekre jelentkezett?" [debounce]="150"></ion-searchbar>
      <ion-list *ngIf="keresoJavaslatok.length" class="tkt-kereso-javaslat" lines="full">
        <ion-item [button]="true" detail="false" *ngFor="let t of keresoJavaslatok" (click)="keresoValaszt(t)">
          <ion-label>{{ t.nev }} <ion-note>{{ t.osztaly || 'nincs aktív osztály' }}</ion-note></ion-label>
        </ion-item>
      </ion-list>

      <div *ngIf="keresoTanulo" class="tkt-kereso-eredmeny">
        <div class="tkt-kereso-fej">
          <strong>{{ keresoTanulo.nev }}</strong>
          <span *ngIf="keresoTanulo.osztaly"> – {{ keresoTanulo.osztaly }}</span>
          <ion-button fill="clear" size="small" (click)="keresoTorles()">Bezár</ion-button>
        </div>
        <ion-spinner *ngIf="keresoToltes" name="dots"></ion-spinner>
        <p *ngIf="!keresoToltes && !keresoTetelek.length" class="tkt-kereso-ures">
          Nem jelentkezett tanórán kívüli tevékenységre, és befizetése sincs.
        </p>
        <ion-list *ngIf="keresoTetelek.length" lines="full">
          <ion-item [button]="true" detail="true" *ngFor="let t of keresoTetelek" (click)="keresoNyit(t)">
            <ion-icon color="primary" slot="start" [name]="t.esemeny.ikon || 'home'"></ion-icon>
            <ion-label class="ion-text-wrap">
              <strong>{{ t.esemeny.nev }}</strong>
              <ion-badge *ngIf="!t.resztvevo" color="medium" class="tkt-kereso-cimke">korábbi résztvevő</ion-badge><br />
              <ion-note>{{ t.esemeny.kezdes | date:'yyyy.MM.dd' }} – {{ t.esemeny.vege | date:'yyyy.MM.dd' }}</ion-note>
              <div *ngIf="t.penzugy" class="tkt-bk-szamok">
                <span *ngIf="t.ar">Ár: <b>{{ arSzoveg(t.esemeny) }}</b></span>
                <span>Befizetve: <b>{{ osszeg(t.befizetve, t.penznem) }}</b></span>
                <span *ngIf="t.hatralek !== null" [class.tkt-hatralek]="t.hatralek > 0">
                  Hátralék: <b>{{ osszeg(t.hatralek, t.penznem) }}</b>
                </span>
              </div>
            </ion-label>
            <ion-badge slot="end" *ngIf="t.penzugy" [color]="allapotSzin(t)">{{ allapotCimke(t) }}</ion-badge>
          </ion-item>
        </ion-list>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Tanórán kívüli tevékenységek</ion-card-title>
    </ion-card-header>
<ion-card-content style="margin:0 !important;padding: 0 !important;">
  <!-- Alapból csak az él, aminek még nincs vége: a jelentkezhető programot nem kell
       kikeresni a múlt közül. Visszanézésnél TANÉVRE szűkítünk (határ: augusztus 31.),
       különben a lista évekkel együtt nő. -->
  <div class="tkt-szuro">
    <ion-item lines="none" class="tkt-kapcsolo">
      <ion-toggle [(ngModel)]="elmultakIs" labelPlacement="end">Elmúltakat is</ion-toggle>
    </ion-item>
    <ion-select *ngIf="elmultakIs" label="Tanév" label-placement="stacked" fill="outline"
                interface="popover" [(ngModel)]="tanev" class="tkt-tanev">
      <ion-select-option *ngFor="let e of tanevek" [value]="e">{{ tanevCimke(e) }}</ion-select-option>
    </ion-select>
    <span class="tkt-darab" *ngIf="feljegyzesek?.length">
      {{ szurtFeljegyzesek.length }} / {{ feljegyzesek.length }}
    </span>
  </div>

  <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="feljegyzesek">
    <ion-item lines="none" *ngIf="!szurtFeljegyzesek.length">
      <ion-label color="medium">
        <i *ngIf="!elmultakIs">Nincs folyamatban vagy előttünk álló tevékenység. Kapcsold be az
          „Elmúltakat is", ha visszanéznél.</i>
        <i *ngIf="elmultakIs">Ebben a tanévben nincs tevékenység.</i>
      </ion-label>
    </ion-item>
    <ion-item [button]="true" detail="false" *ngFor="let f of szurtFeljegyzesek" (click)="openFeljegyzes(f)">
      <ion-icon color="primary" slot="start" [name]="f.ikon || 'home'" size="large"></ion-icon>

      <ion-label>
        <strong>{{f.nev}}</strong><br />
        <ion-note color="" class="ion-text-wrap">
          {{f.kezdes | date:'YYYY-MM-dd'}} - {{f.vege | date:'YYYY-MM-dd'}}, {{f.kezdes | date:'HH:mm'}} - {{f.vege | date:'HH:mm'}}
        </ion-note><br />
        <ion-note color="" class="ion-text-wrap">
          {{f.szoveg || f.tema }}<br>
          <i>{{f.szervezok_nevek}} </i><br><span *ngIf="f.ar">{{ arSzoveg(f) }}</span>
        </ion-note>
      </ion-label>
      <div class="metadata-end-wrapper" slot="end">
        <!-- Munkatársnak a létszám a listán is: a betelt tábor első ránézésre látszik. -->
        <span class="tkt-fo" *ngIf="isPedagogusMode()"
              [class.tul]="f.letszam && (f.jelentkezok_db ?? f.jelentkezok?.length) > f.letszam">
          {{ (f.jelentkezok_db ?? f.jelentkezok?.length) || 0 }}<span *ngIf="f.letszam"> / {{ f.letszam }}</span> fő
        </span>
        <ion-icon color="medium" name="chevron-forward"></ion-icon>
      </div>
    </ion-item>
  </ion-list>
</ion-card-content>

  </ion-card>
  <ion-modal class="" style="z-index: 1000" #feljegyzesmodal >
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="close()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>{{f.nev}}</ion-title>
          <ion-buttons slot="end">
              <ion-button *ngIf="isPedagogusMode() && reszletek?.jog?.penzugy" style="background: white;border-radius: 5px;margin-right: 6px;"
                (click)="csvLetoltes()" [strong]="true" shape="round" color="primary" title="Résztvevők és befizetések táblázatként">CSV</ion-button>
              <ion-button *ngIf="isPedagogusMode()" style="background: white;border-radius: 5px;" (click)="exportPdf()"
                [strong]="true" shape="round" color="primary">PDF</ion-button>
              <ion-button *ngIf="!isPedagogusMode() && !diakMode" style="background: white;border-radius: 5px;" (click)="confirm()"
                [strong]="true" shape="round" color="primary">Mentés</ion-button>
            </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto" *ngIf="!isPedagogusMode()">
        Téma: {{f.szoveg || f.tema }}<br>
        Időpont: {{f.kezdes | date:'YYYY-MM-dd'}} - {{f.vege | date:'YYYY-MM-dd'}}<br>
        Felügyelet: {{f.kezdes | date:'HH:mm'}} - {{f.vege | date:'HH:mm'}}<br>
        <span *ngIf="f.ar">Ár: {{ arSzoveg(f) }}<br></span>
        Évfolyam: {{f.evfolyam}}<br>
        Szervezők: <i>{{f.szervezok_nevek}} </i>

        <ng-container *ngIf="!diakMode">
        <h2>Jelentkezés</h2>
        <ion-list>
                            <ion-item *ngFor="let n of gyerekek; let j = index"
                              [color]="isJelentkezett(n.oktazon) ? 'success' : ''">
                              <ion-label style="flex: 1 !important">{{n.name}}</ion-label>
                              <ion-button (click)="setJelentkezes(n, false)" slot="end"
                                size="default" [color]="!isJelentkezett(n.oktazon) ? 'primary' : 'light'"
                                [disabled]="!isJelentkezett(n.oktazon)"> Nem jelentkezik </ion-button>
                              <ion-button (click)="setJelentkezes(n, true)" slot="end" size="default"
                                [color]="isJelentkezett(n.oktazon) ? 'primary' : 'light'"
                                [disabled]="isJelentkezett(n.oktazon)"> Jelentkezik </ion-button>

                            </ion-item>
                          </ion-list>
        </ng-container>
        <p *ngIf="diakMode" class="tkt-bk-megjegyzes">A jelentkezést a gondviselőd adja le.</p>

        <!-- A saját gyermek(ek) befizetései ennél a tevékenységnél. -->
        <ng-container *ngIf="sajatTetelek(f).length">
          <h2>Befizetések</h2>
          <div class="tkt-befizetes-kartya" *ngFor="let t of sajatTetelek(f)">
            <div class="tkt-bk-fej">
              <strong>{{ t.tanulo.nev }}</strong>
              <ion-badge [color]="allapotSzin(t)">{{ allapotCimke(t) }}</ion-badge>
            </div>
            <div class="tkt-bk-szamok">
              <span>Befizetve: <b>{{ osszeg(t.befizetve, t.penznem) }}</b></span>
              <span *ngIf="t.hatralek !== null" [class.tkt-hatralek]="t.hatralek > 0">Hátralék: <b>{{ osszeg(t.hatralek, t.penznem) }}</b></span>
            </div>
            <ion-progress-bar *ngIf="t.ar" [value]="haladas(t)" [color]="allapotSzin(t)"></ion-progress-bar>
            <ul class="tkt-bk-reszletek" *ngIf="t.befizetesek?.length">
              <li *ngFor="let b of t.befizetesek">
                {{ b.datum | date:'yyyy.MM.dd' }} – <b>{{ osszeg(b.osszeg, b.penznem) }}</b>
                <i *ngIf="b.megjegyzes"> ({{ b.megjegyzes }})</i>
              </li>
            </ul>
          </div>
        </ng-container>
      </ion-content>
       <ion-content class="ion-padding" style="margin: auto" *ngIf="isPedagogusMode()">
        Téma: {{f.szoveg || f.tema }}<br>
        Időpont: {{f.kezdes | date:'YYYY-MM-dd'}} - {{f.vege | date:'YYYY-MM-dd'}}<br>
        Felügyelet: {{f.kezdes | date:'HH:mm'}} - {{f.vege | date:'HH:mm'}}<br>
        <span *ngIf="f.ar">Ár: {{ arSzoveg(f) }}<br></span>
        Évfolyam: {{f.evfolyam}}<br>
        Szervezők: <i>{{f.szervezok_nevek}} </i>

        <!-- RÉSZTVEVŐK. A „+" gomb és a befizetések csak annak jelennek meg, akinek a
             kiszolgáló megengedi (szervező, pénztár, titkárság, admin). -->
        <div class="tkt-resz-fej">
          <h2>Résztvevők</h2>
          <span class="tkt-fo" [class.tul]="letszamTullepve">
            {{ reszletek ? aktivResztvevok.length : ((f.jelentkezok_db ?? f.jelentkezok?.length) || 0) }}<span *ngIf="f.letszam"> / {{ f.letszam }}</span> fő
          </span>
          <ion-button *ngIf="reszletek?.jog?.kezelheti" size="small" shape="round" class="tkt-plusz"
                      (click)="resztvevoHozzaadas()" title="Résztvevő hozzáadása">
            <ion-icon slot="icon-only" name="add"></ion-icon>
          </ion-button>
        </div>
        <p class="tkt-figyelmeztetes" *ngIf="letszamTullepve">
          <ion-icon name="warning-outline"></ion-icon>
          A résztvevők száma meghaladja a férőhelyet ({{ reszletek.esemeny.letszam }} fő).
        </p>

        <div class="tkt-osszesito" *ngIf="reszletek?.jog?.penzugy && reszletek?.osszesites as o">
          <div *ngIf="o.vart !== null"><span>Elvárt</span><b>{{ osszeg(o.vart, o.penznem) }}</b></div>
          <div><span>Befizetve</span><b>{{ osszeg(o.befizetve, o.penznem) }}</b></div>
          <div *ngIf="o.hatralek !== null"><span>Hátralék</span><b [class.tkt-hatralek]="o.hatralek > 0">{{ osszeg(o.hatralek, o.penznem) }}</b></div>
          <div><span>Rendezve</span><b>{{ o.rendezve }} / {{ o.fo }} fő</b></div>
        </div>

        <p *ngIf="reszletekToltes && !reszletek" class="tkt-bk-megjegyzes">Betöltés…</p>

        <!-- Ha a részletek nem jöttek meg, a régi névsor legalább látszik. -->
        <ion-list *ngIf="!reszletek && !reszletekToltes">
          <ion-item *ngFor="let n of jelentkezokRendezve">
            <ion-label style="flex: 1 !important">{{getApplicantName(n)}}</ion-label>
          </ion-item>
        </ion-list>

        <ion-list *ngIf="reszletek" class="tkt-resztvevok">
          <ion-item lines="none" *ngIf="!reszletek.resztvevok.length">
            <ion-label color="medium"><i>Még nincs résztvevő.</i></ion-label>
          </ion-item>
          <ng-container *ngFor="let r of reszletek.resztvevok">
            <ion-item [button]="reszletek.jog.penzugy" detail="false" (click)="reszletek.jog.penzugy && reszletNyit(r)"
                      [class.tkt-korabbi]="!r.resztvevo">
              <ion-label class="ion-text-wrap">
                <strong>{{ r.nev }}</strong> <span class="tkt-osztaly" *ngIf="r.osztaly">{{ r.osztaly }}</span>
                <span class="tkt-osztaly" *ngIf="r.kulsos">külsős</span>
                <p *ngIf="r.kulsos && r.megjegyzes" class="tkt-bk-megjegyzes">{{ r.megjegyzes }}</p>
                <p *ngIf="reszletek.jog.penzugy">
                  Befizetve: <b>{{ osszeg(r.befizetve, r.penznem) }}</b>
                  <span *ngIf="r.ar"> / {{ osszeg(r.ar, r.penznem) }}</span>
                  <span *ngIf="r.hatralek > 0" class="tkt-hatralek"> · hátralék: {{ osszeg(r.hatralek, r.penznem) }}</span>
                  <span *ngIf="r.tulfizetes > 0"> · túlfizetés: {{ osszeg(r.tulfizetes, r.penznem) }}</span>
                </p>
                <p *ngIf="r.elteroPenznemu?.length" class="tkt-hatralek">
                  {{ r.elteroPenznemu.length }} részlet más pénznemben van rögzítve – az összesítőben nem szerepel.
                </p>
              </ion-label>
              <ion-badge slot="end" *ngIf="reszletek.jog.penzugy || !r.resztvevo" [color]="allapotSzin(r)">{{ allapotCimke(r) }}</ion-badge>
              <ion-button slot="end" fill="clear" color="danger" *ngIf="reszletek.jog.kezelheti && r.resztvevo"
                          (click)="$event.stopPropagation(); resztvevoLevesz(r)" title="Levétel a résztvevők közül">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
              <ion-icon slot="end" *ngIf="reszletek.jog.penzugy" color="medium"
                        [name]="nyitottResztvevo === r.oktazon ? 'chevron-up' : 'chevron-down'"></ion-icon>
            </ion-item>

            <!-- A résztvevő részletei: befizetések + új részlet rögzítése. -->
            <div class="tkt-reszletek" *ngIf="reszletek.jog.penzugy && nyitottResztvevo === r.oktazon">
              <table class="tkt-reszlet-tabla" *ngIf="r.befizetesek?.length">
                <tr>
                  <th>Dátum</th><th class="szam">Összeg</th><th>Megjegyzés</th><th>Rögzítette</th><th></th>
                </tr>
                <tr *ngFor="let b of r.befizetesek">
                  <td>{{ b.datum | date:'yyyy.MM.dd' }}</td>
                  <td class="szam">{{ osszeg(b.osszeg, b.penznem) }}</td>
                  <td>{{ b.megjegyzes }}</td>
                  <td>{{ b.rogzitette_nev || b.rogzitette }}</td>
                  <td>
                    <ion-button *ngIf="reszletek.jog.kezelheti" fill="clear" size="small" color="danger"
                                (click)="reszletTorol(r, b)" title="Részlet törlése">
                      <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
                    </ion-button>
                  </td>
                </tr>
              </table>
              <p *ngIf="!r.befizetesek?.length" class="tkt-bk-megjegyzes">Még nincs rögzített befizetés.</p>

              <div class="tkt-uj-reszlet" *ngIf="reszletek.jog.kezelheti">
                <ion-input label="Dátum" labelPlacement="stacked" type="date" fill="outline"
                           [(ngModel)]="ujReszlet.datum"></ion-input>
                <ion-input [label]="'Összeg (' + (r.penznem || reszletek.esemeny.ar_penznem) + ')'" labelPlacement="stacked"
                           type="number" fill="outline" [(ngModel)]="ujReszlet.osszeg"></ion-input>
                <ion-input label="Megjegyzés (a család is látja)" labelPlacement="stacked" fill="outline" maxlength="255"
                           [(ngModel)]="ujReszlet.megjegyzes" class="tkt-megj"></ion-input>
                <ion-checkbox *ngIf="!r.kulsos" labelPlacement="end" [(ngModel)]="reszletErtesites"
                              title="A tanuló üzenetet kap a befizetésről és az állásról (az esemény értesítési csatornáján)">
                  Értesítés a tanulónak</ion-checkbox>
                <ion-button (click)="reszletRogzit(r)">
                  <ion-icon slot="start" name="add"></ion-icon> Részlet rögzítése
                </ion-button>
              </div>
              <p class="tkt-bk-megjegyzes" *ngIf="reszletek.jog.kezelheti">
                Visszafizetésnél negatív összeget rögzíts.
              </p>
            </div>
          </ng-container>
        </ion-list>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
